import React from 'react';
import './Footer.css';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaGithub } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link here


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Social Media Links Section */}
        <div className="footer-section social-links">
          <h4>Follow Us</h4>
          <div className="icon-container">
            <a href="https://www.facebook.com"  rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebook className="social-icon" />
            </a>
            <a href="https://www.twitter.com"  rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter className="social-icon" />
            </a>
            <a href="https://www.instagram.com"  rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className="social-icon" />
            </a>
            <a href="https://www.youtube.com"  rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube className="social-icon" />
            </a>
            <a href="https://www.github.com"  rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub className="social-icon" />
            </a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section quick-links">
  <h4>Quick Links</h4>
  <ul>
    <li><Link to="/about">About Us</Link></li>
    <li><Link to="/ServicePage">Services</Link></li>
    <li><Link to="/ContactPage">Contact</Link></li>
  </ul>
</div>
      </div>

      {/* Footer Text */}
      <div className="footer-bottom">
      <div className="footer">
  <p className="footer-text">
    © 2024 Codeprowl Technologies💻✔️. All Rights Reserved.
  </p>
  <p className="footer-subtext">
    Designed and Developed by Codeprowl Technologies | Privacy Policy | Terms of Service
  </p>
  </div>

        </div>
    </footer>
  );
}

export default Footer;
